'use client';

import React, { useEffect, useRef, useState } from 'react';
import { motion, useAnimationControls, useMotionValueEvent, useScroll } from 'framer-motion';
import cx from 'classnames';

interface IViewport {
    className?: string;
    collapsed: boolean;
    children?: React.ReactNode;
    onScroll?: (y: number) => void;
}

const Viewport = ({ className = '', collapsed, children, onScroll }: IViewport) => {
    const ref = useRef(null);
    const controls = useAnimationControls();
    const scroll = useScroll({ container: ref });
    const [distanceY, setYDistance] = useState<number>(0);

    useEffect(
        () => {
            const transitionWidth = window.innerWidth < 640
                ? '-100vw'
                : '-640px';

            controls.start({ x: ! collapsed ? transitionWidth : '0px' });
        },
        [controls, collapsed]
    );

    useMotionValueEvent(scroll.scrollY, 'change', (latest) => {
        setYDistance(latest);

        if (typeof onScroll === 'function') {
            onScroll(distanceY);
        }
    });

    return (
        <motion.div
            id='app'
            ref={ref}
            initial={{
                x: '0px'
            }}
            animate={controls}
            transition={{
                type: 'spring',
                mass: 0.3,
                damping: 13
            }}
            className={cx('relative overflow-x-hidden overflow-y-scroll w-full h-full max-h-full', {
                [className]: Boolean(className)
            })}
        >
            {children}
        </motion.div>
    );
};

export default Viewport;